import React from "react";
import { Spinner } from "@shared/ui/spinner";
import classes from "./report-loading.module.scss";

export const ReportLoading = () => (
    <div className={classes["report-loading"]}>
        <Spinner />
        <div className={classes["report-loading__text"]}>Отчёт загружается</div>
    </div>
);